import React from 'react';
import { SVGProps } from 'react';
import { clsx } from 'clsx';
import { IconProps, iconVariants } from '../icon';
import '../icon/icon.module.scss';
type Props = IconProps & Omit<SVGProps<SVGSVGElement>, keyof IconProps>;
const ChevronDownLight = React.forwardRef<SVGSVGElement, Props>(
  ({ color, size, opacity = 1, className, ...props }, ref) => {
    const classes = clsx(
      iconVariants({
        color,
        size,
      }),
      className,
    );
    const style: React.CSSProperties = {
      '--opacity': opacity,
    };
    return React.cloneElement(
      <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" ref={ref} {...props}>
        <g fill="currentColor">
          <path d="M12 17.5a1 1 0 0 1-.707-.293l-9-9a1 1 0 1 1 1.414-1.414l9 9A1 1 0 0 1 12 17.5" />
          <path d="M12 17.5a1 1 0 0 1-.707-1.707l9-9a1 1 0 1 1 1.414 1.414l-9 9A1 1 0 0 1 12 17.5" />
        </g>
      </svg>,
      {
        role: 'presentation',
        focusable: false,
        className: classes,
        'aria-hidden': true,
        style,
        ...props,
      },
    );
  },
);
ChevronDownLight.displayName = 'ChevronDownLight';
export default ChevronDownLight;
